export const DEBOUNCE_DELAY = 500



// WEBPACK FOOTER //
// ./src/config/search.config.js